import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hpsfir-card config" }

import { ref } from 'vue';
import Recharge from './recharge/index.vue';
import PointsRule from './pointsrule/index.vue';
import InviteRule from './inviterule/index.vue';
import SignRule from './signrule/index.vue';
import WifiConfig from './wificonfig/index.vue';
import StoreNotice from './storenotice/index.vue';
import TodayActivity from './todayactivity/index.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeTab = ref('recharge');

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      class: "config-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "D币套餐",
          name: "recharge"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'recharge')
              ? (_openBlock(), _createBlock(Recharge, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "存积分规则配置",
          name: "pointsRule"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'pointsRule')
              ? (_openBlock(), _createBlock(PointsRule, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "邀请奖励配置",
          name: "inviteRule"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'inviteRule')
              ? (_openBlock(), _createBlock(InviteRule, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "签到赠送积分配置",
          name: "signRule"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'signRule')
              ? (_openBlock(), _createBlock(SignRule, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "WiFi信息配置",
          name: "wifiConfig"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'wifiConfig')
              ? (_openBlock(), _createBlock(WifiConfig, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "本店须知与规则",
          name: "storeNotice"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'storeNotice')
              ? (_openBlock(), _createBlock(StoreNotice, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "今日活动",
          name: "todayActivity"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'todayActivity')
              ? (_openBlock(), _createBlock(TodayActivity, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})